<template>
    <div class="container" style="">
        <iframe src="https://a.mgt.test.yijiajiayun.com/data/yuhang.htm" frameborder="0" style="width: 100%;height: 100%;" ></iframe>
        
        
    </div>
</template>

<script>
    export default {
        name: 'adminIndex',
        data() {
            return {

            }
        },
        computed: {
            
        },
        // watch: {
        //   '$route' (to, from) {
        //       console.log("路由变化------")
        //       console.log(to,from)
        //   }
        // },
        components: {
        },
        methods: {
            back() {
                this.$router.back()
            },
        },
        created() {
            console.log("执行created")
        
        },
        mounted(){
            console.log("执行mounted")
        }
    }
</script>

<style scoped lang="scss">
    @media screen and (max-width: 1440px) {//小屏幕
        .container{
            // border:1px solid blue;
            width: 100%;
            // height:calc(100vh-100px);
            height: 480px;
        }
    }
    @media screen and (min-width: 1440px) {//大屏幕
        .container{
            width: 100%;
            // height:calc(100vh-100px);
            height: 750px;
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/pages/customer/yhList.vue